import {HarCreator} from './harCreator';
import {HarPage} from './harPage';
import {HarEntry} from './harEntry';

export class HarLog {
  version: string;
  creator: HarCreator;
  pages: HarPage[];
  entries: HarEntry[];

  constructor(startDate: Date) {
    this.version = '1.2';
    this.creator = new HarCreator();
    this.pages = [new HarPage(startDate)];
    this.entries = [];
  }
}

